import { onMounted } from 'vue';

type MissingNameWarning = {
  isNamed: boolean;
  component: string;
  role: string;
  hint: string;
};

export function useMissingNameWarning({
  isNamed,
  component,
  role,
  hint,
}: MissingNameWarning) {
  onMounted(() => {
    if (import.meta.env.DEV && !isNamed) {
      console.warn(
        `${component} has no accessible name: ${hint}. It will be announced as an unnamed ${role}.`,
      );
    }
  });
}
